const defaultType = 'maint';

const defaultLocations = {
    1: "Unit 1",
    2: "Unit 2",
    3: "Unit 3",
    4: "Unit 4",
    5: "Unit 5",
    6: "Unit 6",
    7: "Unit 7",
    8: "Unit 8",
    9: "Unit 9",
    10: "Unit 10",
    12: "Parking",
    14: "Laundry"
};
const defaultWorkItems = {
    1: "Daily inspection",
    2: "Outdoor drain inspection",
    3: "Outdoor drain cleaning",
    4: "Outdoor plant maintenance",
    5: "Laundry room cleaning",
    6: "Laundry room maintenance",
    7: "Quarterly plumbing inspection",
    8: "Annual furnace inspection",
    9: "Annual window cleaning",
    10: "Review security footage",
    11: "Parking lot maintenance",
    12: "Watering lawns",
};

const INTERVAL_MIN = 5;

class Model {
    constructor(storage) {
        this.storage = storage;
        this.capture = {
            Type: defaultType,
            Trades: "0.0",
            Task: "",
            Locations: [],
            Date: "",
            Maint: "0.0",
            Purchase: "0.0"
        };
    }
    locations(callback) {
        callback(defaultLocations);
    }
    workItems(callback) {
        callback(defaultWorkItems); 
    }
    nextDate(current, increment, callback) {
        const date = this._calculateDate(current, increment);
        callback(date);
    }
    setTaskType(taskType, callback) {
        this.capture.Type = taskType;
        callback(taskType);
    }
    setAmount(amount, callback) {
        switch (this.capture.Type) {
            case 'maint':
                this.capture.Maint = parseFloat(amount);
                break;                
            case 'purch':
                this.capture.Purchase = parseFloat(amount);
                break;                
            case 'trade':
                this.capture.Trades = parseFloat(amount);
                break;
            default:
                console.log("Error : ", capture.type)
                break;
        }
        callback(amount);
    }
    updateAuth(authCode, callback) {
        // should this be delegated to the store ???
        localStorage.setItem("authCode", authCode); 
    }
    hasAuthCode() {
        // should this be delegated to the store ???
        const value = localStorage.getItem("authCode");
        return value !== null && value.length > 16; // arbitrary length validation
    }
    updateWorkItem(content, callback) {
        this.capture.Task = content;
        callback(content);
    }
    appendLocation(value, callback) {
        this.capture.Locations.push(value)        
        callback(value);
    }
    updateRemote() {
        const stat = this.storage.summary();
        if (this._shouldUpload(stat.update)) { 
            this.storage.upload();
        }
    }
    read(date, callback) {
        this.storage.load(date, (data) => { 
            if (this._shouldUpload(data.summary.updated)) {
                this.storage.upload();
            }
            this._clearCapture();
            const stat = this.storage.summary()
            const items = this.storage.findAll((e,i,a) => { return e.Date === date }) ?? [];
            callback(items, stat)
        });
    }
    findWorkItem(filter) {
        return this.storage.findAll(filter)
    }
    removeWorkItem(date, filter, callback) {
        this.storage.remove(filter);
        const stat = this.storage.summary()
        const items = this.storage.findAll((e,i,a) => { return e.Date === date }) ?? [];
        callback(items, stat);
    }
    saveWorkItem(date, callback) {
        this.capture.Date = date;
        try {
            this._ensureUnique(date)
            this.storage.save(this.capture, (update) => { 
                this._clearCapture();
                const stat = this.storage.summary()
                const items = this.storage.findAll((e,i,a) => { return e.Date === date }) ?? [];
                callback(update, items, stat);
            });
        } catch (error) {
            alert(error);
            throw error;
        }
    }
    clearStorage() {
        if (window.confirm("Are you sure you want to clear all workitems?\n")) {
            this.storage.clear();
        }
    }
    validate(callback) {
        callback(this._isValidTask());
    }

    _clearCapture() {
        this.capture.Maint = "0.0";
        this.capture.Purchase = "0.0";
        this.capture.Trades = "0.0";
        this.capture.Locations = [];
    }
    _calculateDate(current, direction) {
        // assumes direction is either 1 or -1
        var value = new Date(current);
        value.setDate(new Date(current).getDate() + direction);
        const m = (value.getMonth() + 1).toString().padStart(2, '0');
        const d = value.getDate().toString().padStart(2, '0');
        return `${value.getFullYear()}-${m}-${d}`;
    }
    _ensureUnique(date) {
        let c = this.capture;
        let filter = (e,i,a) => { 
            return e.Type === c.Type 
            && parseFloat(e.Maint) === parseFloat(c.Maint) 
            && parseFloat(e.Purchase) === parseFloat(c.Purchase) 
            && parseFloat(e.Trades) === parseFloat(c.Trades) 
            && e.Date === date
            && e.Task.trim() === c.Task.trim() 
        };        
        const items = this.findWorkItem(filter) ?? [];
        if (items.length){
            console.log("duplicates: ", c, items);
            throw Error("duplicates found")
        }
        return;
    }
    _isValidTask() {
        return (this.capture.Type !== null) 
            && (parseFloat(this.capture.Maint)+parseFloat(this.capture.Purchase)+parseFloat(this.capture.Trades)) >= 0
            && this.capture.Task.length > 7;
    }
    _shouldUpload(timestamp) {
        const lastUpdated = new Date(timestamp);
        return (((new Date()-lastUpdated)/1000)/60) > INTERVAL_MIN; // minutes
    }
}

export default Model;
